module.exports = __webpack_public_path__ + "img/tree-06-g-trunk.3ff2aa5f.png";